import { UnconnectedPageTemplate, Button } from "@endya-conformite/ui-kit";
import { useSession } from "@src/data/session/UserSessionContext";
import { useNavigate } from "react-router-dom";
import styles from "./NotFoundPage.module.scss";

export function NotFoundPage() {
  const navigate = useNavigate();
  const session = useSession();

  return (
    <UnconnectedPageTemplate>
      <div className={styles.content}>
        <h1 className={styles.errorCode}>404</h1>
        <h2>
          <b>La page à laquelle vous tentez d&apos;accéder est introuvable</b>
        </h2>
        <p className={styles.description}>
          Il est possible que l&apos;adresse URL soit incorrecte, que la page
          ait été déplacée, renommée ou supprimée.
        </p>
        <div className={styles.actions}>
          <Button
            onClick={() => {
              if (session.isConnected) {
                navigate("/");
              } else {
                navigate("/login");
              }
            }}
            variant="text"
          >
            {session.isConnected
              ? "Retour à la page d'accueil"
              : "Se connecter"}
          </Button>
        </div>
      </div>
    </UnconnectedPageTemplate>
  );
}
